import {
  Table,
  TableContentSelector,
  TableFiltering,
  TablePageSizeSelector,
  TablePagination,
  TablePreferences,
  Toggle,
} from 'AWS-UI-Components-React';

import { TEXT, PAGINATION, TOGGLE_PLACEMENT } from '../common/constants';

/**
 * Displays the main body (table) of the report.
 */
export class ReportTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const {
      loading,
      displayInMillions,
      reportRows,
      columnDefinitions,
      contentSelectorOptions,
      onContentSelectionChange,
      onToggleMillions,
      togglePlacement,
      showTableFilter,
      wrapLines,
    } = this.props;

    const toggleInHeader = togglePlacement === TOGGLE_PLACEMENT.IN_HEADER;

    return (
      <div>
        <Table
          className="ZebraStripesTable accuracy-table-container"
          columnDefinitions={columnDefinitions}
          loading={loading}
          loadingText={TEXT.LOADING}
          items={reportRows}
          stickyHeader={true}
          onBeforeUnstick={(event) => event.preventDefault()}
          onContentSelectionChange={onContentSelectionChange}
          wrapLines={wrapLines || false}
          data-cy="accuracy-table"
          header={
            <div className="awsui-util-action-stripe">
              <div className="awsui-util-action-stripe-title" />
              <div className="awsui-util-action-stripe-group">
                {!toggleInHeader && (
                  <Toggle
                    label={TEXT.DISPLAY_IN_MILLIONS}
                    checked={displayInMillions}
                    disabled={loading}
                    onChange={onToggleMillions}
                  />
                )}
              </div>
            </div>
          }
          empty={
            <div className="awsui-util-t-c">
              <div className="awsui-util-pt-xs awsui-util-mb-xs">
                <b>{TEXT.EMPTY}</b>
              </div>
            </div>
          }
        >
          {toggleInHeader && (
            <Toggle
              label={TEXT.DISPLAY_IN_MILLIONS}
              checked={displayInMillions}
              disabled={loading}
              onChange={onToggleMillions}
            />
          )}
          {showTableFilter && <TableFiltering filteringPlaceholder="Filter" />}
          &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          <TablePagination pageSize={PAGINATION.SIZE} />
          <TablePreferences
            id="table-preferences"
            title={TEXT.PREFERENCES}
            confirmLabel={TEXT.CONFIRM}
            cancelLabel={TEXT.CANCEL}
          >
            <TablePageSizeSelector title="Page size" options={PAGINATION.SELECTOR} value={PAGINATION.SIZE} />
            <TableContentSelector title="Select visible columns" options={contentSelectorOptions} />
          </TablePreferences>
        </Table>
        {
          <div align="right">
            <small>v2</small>
          </div>
        }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/reports/components/report_table.js